var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg171(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 131,
    viewBox: "0 0 78 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999931 129.66C24.3333 106.993 69 60.1602 75.9999 26.6602C83.2314 -7.94774 41.0001 -1.33985 10.0001 10.6602",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7688 42.6602C40.024 40.261 36.9992 36.7588 40.2688 34.2157C41.2981 33.4152 43.9027 33.2114 44.5466 34.6602C46.5987 39.2773 36.4414 44.5148 33.7688 45.6602",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg171);
export default __webpack_public_path__ + "static/media/171.824f15b7880547f45495ce782f69d49b.svg";
export { ForwardRef as ReactComponent };